import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const apiUrl = process.env.REACT_APP_API_URL;

export const eventService = createApi({
    reducerPath: "eventService",
    baseQuery: fetchBaseQuery({
        baseUrl: apiUrl,
        prepareHeaders: (headers, { getState }) => {
            const token = JSON.parse(localStorage.getItem('auth'))?.jwt;

            // If we have a token set in state, let's assume that we should be passing it.
            if (token) {
                headers.set("authorization", `Bearer ${token}`);
            }
            headers.set('Content-type', 'application/json')
            headers.set('Accept', 'application/json')
            return headers;
        }
    }),

    endpoints: (builder) => ({
        getEvents: builder.query({
            query: () => "/evenements",
        }),
        addEvent: builder.mutation({
            query: (newEvent) => ({
                url: "/evenements",
                method: "POST",
                body: newEvent,
            }),
        }),
        updateEvent: builder.mutation({
            query: ({ id, ...updatedEvent }) => ({
                url: `/evenements/${id}`,
                method: "PUT",
                body: updatedEvent,
            }),
        }),
        deleteEvent: builder.mutation({
            query: (id) => ({
                url: `/evenements/${id}`,
                method: "DELETE",
            }),
        }),
    }),
});

export const {
    useGetEventsQuery,
    useAddEventMutation,
    useUpdateEventMutation,
    useDeleteEventMutation,
    useLazyGetEventsQuery,
} = eventService;
